import { apiFetch } from '../lib/apiFetch';

export interface FlaggedTask {
  id: string;
  order_id: string;
  order_number: string;
  task_type: string;
  customer_name: string;
  location: string;
  notes: string;
  driver: string | null;
  scheduled_date: string;
  updated_at: string;
}

export const completeTask = async (taskId: string): Promise<void> => {
  const response = await apiFetch(`/tasks/${taskId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status: 'completed' }),
  });
  if (!response.ok) throw new Error(`Failed to complete task: ${response.statusText}`);
};

export const flagTask = async (taskId: string, notes: string): Promise<void> => {
  const response = await apiFetch(`/tasks/${taskId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ status: 'problem', notes }),
  });
  if (!response.ok) throw new Error(`Failed to flag task: ${response.statusText}`);
};

export const fetchFlaggedTasks = async (): Promise<FlaggedTask[]> => {
  const response = await apiFetch(`/tasks?status=problem`);
  if (!response.ok) throw new Error(`Failed to fetch flagged tasks: ${response.statusText}`);
  const data = await response.json();
  return data.data || [];
};
